module.exports = __webpack_public_path__ + "img/noimagesimg.38c6b33e.png";